import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { WrappingCellText } from './WrappingCellText';

const DETAIL_LINE_CLASS = 'text-xs text-muted-foreground';

interface StackedCellTextProps {
  primary: ReactNode;
  secondary?: ReactNode | undefined;
  tertiary?: ReactNode | undefined;
  quaternary?: ReactNode | undefined;
  primaryClassName?: string | undefined;
  isCentered?: boolean | undefined;
}

function hasContent(value: ReactNode): boolean {
  return value !== null && value !== undefined && value !== '' && value !== false;
}

export function StackedCellText({
  primary,
  secondary,
  tertiary,
  quaternary,
  primaryClassName,
  isCentered = false,
}: StackedCellTextProps) {
  return (
    <WrappingCellText
      width={isCentered ? 'fill' : 'default'}
      className={cn('flex flex-col', isCentered && 'items-center text-center')}
    >
      <span className={primaryClassName}>{primary}</span>
      {hasContent(secondary) ? <span className={DETAIL_LINE_CLASS}>{secondary}</span> : null}
      {hasContent(tertiary) ? <span className={DETAIL_LINE_CLASS}>{tertiary}</span> : null}
      {hasContent(quaternary) ? <span className={DETAIL_LINE_CLASS}>{quaternary}</span> : null}
    </WrappingCellText>
  );
}
